<template>
  <div :class="['site', `site--${currentPage}`]" id="app">
    <main-header />
    <router-view />
    <main-footer />
    <off-canvas />
    <svg-sprite />

    <cookie-law 
      style="background-color: #1da6d9; color: #fff"
    >
      <div id="content-cookie" slot-scope="props">
        <div>
            <p class="cn-text-bold cn-text">A Oxfam Brasil utiliza cookies e outras tecnologias semelhantes para melhorar a sua experiência.</p>
            <p class="cn-text-bold cn-text">Ao navegar pelo site, você autoriza o uso dessas tecnologias.</p>
        </div>
        <div class="text-center">
          <a id="link-cookie" target='_blank' href='https://www.oxfam.org.br/politica-de-privacidade/?_ga=2.227638485.937008516.1617664427-1960657114.1617234060'>
              <p>Saiba mais em nossa</p>
              <p>Política de Privacidade</p>
          </a>
        </div>
        
        <button class="skew" @click="props.accept"><span>Ok, entendi.</span></button>
      </div>
    </cookie-law>
  </div>
</template>

<style lang="scss">
.site {
  position: relative;

  min-height: 100vh;

  margin: 0;

  min-height: 100vh;
  width: 100%;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: $main-font-color;
  font-family: $font-family--body;
  font-weight: 400;

  backface-visibility: hidden;

  @media #{$large-up} {
    padding-top: rem-calc(102);

    &.site--home {
      padding-bottom: rem-calc(104);

      @media screen and (max-height: rem-calc(683)) and (min-width: rem-calc(984)) {
        padding-bottom: rem-calc(84);
      }
    }
  }
}

#content-cookie{
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 2rem;
  max-width: 72.1875rem;
  margin: 0 auto;
  margin-top: 20px;
  padding-bottom: 10px;
}

#link-cookie {
  color: #FFF;
  text-decoration: underline;
}

#content-cookie #fontSmall{
  font-size: 12px;
}

.cn-text-bold {
  font-weight: 700;
}

.cn-text {
  font-size: 1.1rem;
  font-family: "oxfam-regular";
  display: block;
  margin: 0px;
}

#link-cookie p {
  font-size: 14px !important;
  margin: 0px;
}

.text-center {
  text-align: center;
}

.skew {
  background-color: #fff; 
  color: #1da6d9;
  font-size: 15px !important;
  border: 0px;
  font-family: sans-serif;
  border-radius: 3px;
  font-style: normal;
  height: 40px;
}

</style>

<script>
import MainHeader from '@/components/Header.vue';
import MainFooter from '@/components/Footer.vue';
import Offcanvas from '@/components/Offcanvas.vue';
import SvgSprite from '@/components/SvgSprite.vue';
import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    'main-header': MainHeader,
    'main-footer': MainFooter,
    'off-canvas': Offcanvas,
    'svg-sprite': SvgSprite,
    CookieLaw
  },
  computed: {
    currentPage() {
      return this.$route.name;
    },
  },
};
</script>
